<template>
	<div class="container-wrap cs_page">
		<div class="customer_top_wrap">
			<div>{{ $t('cs.title') }}</div>
		</div>
		<div class="container-box">
			<div class="customer_tab_box">
				<ul class="customer_tab_list">
					<li
						v-for="(tabInfo, idx) in tabs"
						:key="tabInfo.type"
						:class="{ active: selectedTabIdx === idx }"
					>
						<a class="tab_item" @click="tabSelect(idx)">
							<span>{{ $t(tabInfo.lang_code) }}</span></a
						>
					</li>
				</ul>
			</div>
		</div>
		<div class="container-box">
			<component :is="tabs[selectedTabIdx].type" @goList="goList"></component>
		</div>
		<!-- <div class="bottom d_flex justify_center">
			<div class="d_flex mr_40">
				<p>{{ $t('banner2.text1') }}</p>
				<span>10:00 - 19:00 {{ $t('banner2.text2') }} </span>
			</div>
			<div class="d_flex mr_40">
				<p>{{ $t('banner2.text3') }}</p>
				<span>{{ $t('banner2.text4') }}{{ $t('banner2.text5') }}</span>
			</div>
			<div class="d_flex">
				<p>{{ $t('banner2.text6') }}</p>
				<span>10:00 - 19:00 {{ $t('banner2.text7') }} </span>
			</div>
		</div> -->
	</div>
</template>

<script>
import Notice from '@/components/Service/Cs/Notice';
import Inquiry from '@/components/Service/Cs/Inquiry';
import InquiryDetail from '@/components/Service/Cs/InquiryDetail';
import Faq from '@/components/Service/Cs/Faq';
import { fetchFaqList, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'Cs',
	components: {
		Notice,
		Inquiry,
		InquiryDetail,
		Faq,
	},
	data() {
		return {
			selectedTab: 1,
			isWrite: true,
			faqList: [],
			faqTypeList: [],
			inquiryList: [],
			noticeList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,

			parent_seq: '',
			type_seq: '',
			title: '',
			content: '',
			email_address: '',
			password: '',
			field_values: [],
			ticket_type_list: [],
			ticket_id: '',
			selectedTabIdx: 0,
			tabs: [
				{
					type: 'notice',
					lang_code: 'cs.notice',
				},
				{
					type: 'inquiry',
					lang_code: 'cs.inquiry.inquiry',
				},
				{
					type: 'inquiry-detail',
					lang_code: 'cs.inquiry.list',
				},
				{
					type: 'faq',
					lang_code: 'cs.faq',
				},
			],
		};
	},
	created() {
		this.setInitialTab();
		this.init2();
		this.init3();
	},
	methods: {
		setInitialTab() {
			const path = this.$route.path;
			if (
				path.includes('/cs/cs') ||
				path === '/service/cs' ||
				path === '/service/cs/'
			) {
				this.selectedTabIdx = 0;
			} else if (path.includes('/notice')) {
				this.selectedTabIdx = 0; // notice 탭
			} else if (path.includes('/inquiry')) {
				this.selectedTabIdx = 1; // inquiry 탭
			} else if (path.includes('/faq')) {
				this.selectedTabIdx = 3; // faq 탭
			} else {
				this.selectedTabIdx = 0;
			}
		},
		tabSelect(idx) {
			this.selectedTabIdx = idx;
		},
		init() {
			Promise.all([this.loadFaqTypeList()]).then(() => {
				this.loadNoticeList();
			});
		},

		init2() {
			this.loadFaqList();
		},
		init3() {
			this.loadTicketTypeList();
		},
		async loadFaqList() {
			const params = {
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.faqList = data;
			this.pageNavigation = page_navigation;
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticket_type_list = data;
		},

		goList() {
			this.selectedTabIdx = 2;
		},
	},
};
</script>

<style scoped>
.rtr_cs .tab_area {
	width: 1200px;
	margin: 0 auto;
}
.rtr_cs .border_bottom {
	border-bottom: 1px solid #ddd;
}

.rtr_cs .tab_area li a {
	padding: 30px 25px;
}
.rtr_cs .container {
	padding: 69px 0 0;
}
.rtr_cs .content {
	width: 100%;
}
.rtr_cs section .title {
	margin-bottom: 30px;
	font-size: 36px;
	line-height: 1.2;
	letter-spacing: -1.8px;
}
.rtr_cs section .text {
	font-size: 20px;
	font-weight: 300;
	line-height: 1.33;
	letter-spacing: -0.38px;
}
.rtr_cs .sub_content1 {
	width: 100%;
	height: 230px;
	margin: 0 auto;
	background: #1e1e1e;
	color: #fff;
}
.rtr_cs .sub_content1 {
	background: url('~@/assets/images/sub/cs.png') #000;
	background-size: cover;
}
.rtr_cs .tap_wrap {
	padding: 70px 0;
	width: 1200px;
	margin: 0 auto;
}
.notice_no {
	border-bottom: 1px solid #ddd;
}
.notice_no p {
	padding: 20px 0;
	text-align: center;
	font-size: 16px;
}
.rtr_cs .bottom {
	position: absolute;
	bottom: 0;
	width: 100%;
	padding: 15px 0;
	background: #f0f0f0;
}
.rtr_cs .bottom p {
	margin-right: 10px;
	font-size: 15px;
	font-weight: 600;
}
.rtr_cs .bottom span {
	font-size: 15px;
	font-weight: 300;
}
.mr_40 {
	margin-right: 40px;
}
.customer_top_wrap {
	width: 100%;
	height: 225px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	font-size: 34px;
	line-height: 36px;
	color: #fff;
	background-image: url('~@/assets/images/v2/bg-customer.png');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
}
.customer_tab_list {
	display: flex;
	gap: 10px;
	padding: 0;
	margin-top: 80px;
	padding-bottom: 20px;
	border-bottom: 1px solid #f0f0f0;
	margin-bottom: 20px;
}
.customer_tab_list li a {
	font-weight: 500;
	font-size: 16px;
	line-height: 18px;
	color: #cdcdcd;
	height: 48px;
	border: 1px solid #f0f0f0;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 20px;
}
.customer_tab_list li.active a {
	font-weight: bold;
	color: #2a5cda;
	border: 1px solid #2a5cda;
}
@media screen and (max-width: 768px) {
	.customer_top_wrap {
		height: 140px;
		font-size: 20px;
		line-height: 22px;
	}
	.customer_tab_box {
		overflow-x: auto;
		/* 스크롤바 숨기기 */
		scrollbar-width: none; /* Firefox */
		-ms-overflow-style: none; /* Internet Explorer 10+ */
	}
	.customer_tab_box::-webkit-scrollbar {
		display: none; /* 웹킷 브라우저에서 스크롤바 숨기기 */
	}
	.customer_tab_list {
		margin-top: 20px;
		padding-bottom: 10px;
		margin-bottom: 10px;
		width: 450px;
	}
	.customer_tab_list li a {
		font-size: 12px;
		height: 38px;
		line-height: 14px;
		padding: 0 12px;
	}
}
</style>
